module.exports = __webpack_public_path__ + "img/link-banner-es.bbb00070.png";